<template>
  <div class="QingXi">
    <!-- 夏季：6-8月 -->
    <div class="summer" v-if="nowMoth >= 6 && nowMoth <= 8">
      <div class="banner">
        <img width="100%" src="../../../assets/img/QingXi/summer_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/QingXi/summer_cheliziPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/QingXi/summer_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              清溪甜樱桃于上世纪80、90年代开始种植，主要种植品种有红灯、拉宾斯、美早、冰库等，由于独特的气候条件，清溪镇甜樱桃果大、色泽鲜艳、含糖量高、裂果少、病虫害轻，且成熟早，市场竞争力强。以红灯为例，最早可在“五一黄金周”采收，5月30日——6月15日开始大量上市，紫红色，平均单果重15G。销售到较远地方时，可在果色鲜红而未转紫色时采收，此时果子硬度较大，便于长途运输。同时，由于海拔高、垂直气候明显以及小气候差异大，同一品种在不同海拔高度成熟期相差很大，可延长供应期，仅红灯品种的成熟期最早和最晚可相差30天。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/QingXi/summer_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QingXi/summer_square.png')" color="#B71D3B"
        borderBottomColor="#B71D3B" boxBorderColor="#E5C6CE" btnBJcolor="#D47D8E" hoverBJcolor="#AF0124">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QingXi/summer_square.png')" color="#B71D3B"
        borderBottomColor="#B71D3B"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/QingXi/summer_square.png')" color="#B71D3B"
        borderBottomColor="#B71D3B" boxBorderColor="#E5C6CE"></ztxzList>
    </div>
    <!-- 秋季：9-11月 -->
    <div class="autumn" v-else-if="nowMoth >= 9 && nowMoth <= 11">
      <div class="banner">
        <img width="100%" src="../../../assets/img/QingXi/autumn_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/QingXi/autumn_huajiaoPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/QingXi/autumn_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              清溪花椒历史悠久，声名远播，蜚声中外。自唐代元和年间(约公元805-820年)就被列为贡品，历朝历代都作为贡品进贡皇室，故又名“贡椒"。以其色泽丹红，粒大油重，芳香浓郁、醇麻爽口等独一无二的品质而享誉全国。以得天独厚的地理气候优势，清溪花椒挥发性芳香油含量8%-12%，其它花椒为3%-7%。芳樟醇含量在53.34%，远高于其他种类花椒。
            </p>
            <p>
              现种植面积1133HM2，主要种植品种有正路椒、大红袍等，建成以顺利村为主核心的“千亩贡椒示范基地”，按照“合作社+基地+农户”的生产模式，推行肥水一体化、机械化作业等技术，实现统一采摘统一销售。清溪贡椒种植密度在120-150株/亩，产量可达到250-300KG/亩，收入可达到6000-10000元/亩。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/QingXi/autumn_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QingXi/autumn_square.png')" color="#384890"
        borderBottomColor="#384890" boxBorderColor="#D4D6E0" btnBJcolor="#8F9AC8" hoverBJcolor="#283D9A">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QingXi/autumn_square.png')" color="#384890"
        borderBottomColor="#384890"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/QingXi/autumn_square.png')" color="#384890"
        borderBottomColor="#384890" boxBorderColor="#D4D6E0"></ztxzList>
    </div>
    <!-- 四季 -->
    <div class="winter" v-else>
      <div class="banner">
        <img width="100%" src="../../../assets/img/QingXi/banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/QingXi/dianliPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/QingXi/square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p style="line-height: 28px;">
              汉源县清溪风电场项目位于清溪镇永安村，距离清溪镇政府5公里、县城38公里，由四川汉源铁能新能源开发有限公司投资开发建设。项目一期工程计划总投资4.6亿元，设计规模为19台单机，总装机容量47.5MW，设计年平均发电量9510.8万千瓦时。工程于2015年2月开工建设，于2016年9月完工，11月实现竣工验收；2017年1月25日启动试运行，2月8日正式进入商业运营。2017年，项目累计发电6349万千瓦时，实现主营业务收入2886万元,2017年9月份纳入规模企业统计，实现了当年投产当年入规入统。2018年， 累计发电6828万千瓦时，实现主营业务收入3315万元。2019年，累计发电7577万千瓦时，实现主营业务收入3663万元。2020年， 累计发电6890万千瓦时，实现主营业务收入3269.05万元。2021年， 清溪风电场共计发电量6210.59万千瓦时，实现发电收入2896.46万元(含国补)。目前，清溪风电场项目二期工程正在做前期准备工作。
            </p>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QingXi/square.png')" color="#0AABD8"
        borderBottomColor="#0AABD8" boxBorderColor="#D2E6EC" btnBJcolor="#7CCDE8" hoverBJcolor="#0FA0D5">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QingXi/square.png')" color="#0AABD8"
        borderBottomColor="#0AABD8"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/QingXi/square.png')" color="#0AABD8"
        borderBottomColor="#0AABD8" boxBorderColor="#D2E6EC"></ztxzList>
    </div>
  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'QingXi',
  components: { ztxzList, ConvenientService,GovernmentServices },
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: this.$route.params.mapId || null,  //点位ID
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'清溪镇'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);
  },
  // mounted() {
  //   // if (this.$route.params.mapId) {
  //   //   sessionStorage.setItem('mapId', this.mapId)
  //   // }
  //   // if (sessionStorage.getItem('mapId')) {
  //   //   this.mapId = sessionStorage.getItem('mapId');
  //   // }
  //   this.getData();
  //   this.getMatterList();
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 获取便民办事
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else {
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //         }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  // },
};
</script>
<style scoped>
.QingXi {
  background: url('../../../../src/assets/img/QingXi/bg.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.spring .top_title {
  color: #2E80C6;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #2E80C6;
  height: 12%;
}

.summer .top_title {
  color: #B71D3B;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #B71D3B;
  height: 12%;
}

.autumn .top_title {
  color: #384890;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #384890;
  height: 12%;
}

.winter .top_title {
  color: #0AABD8;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #0AABD8;
  height: 12%;
}

.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}</style>